import React from "react";
import Form from "react-bootstrap/lib/Form";
import { Fields } from "./Fields";

export const ExtraFields = ({
  includeExtraFields,
  extraFields,
  values,
  errors,
  handleBlur,
  handleChange,
  setFieldValue,
}) => {
  if (!includeExtraFields || !extraFields?.length) return null;

  return (
    <Form.Row
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "2rem",
        marginTop: "2rem",
        marginBottom: "1rem",
      }}
    >
      {extraFields
        .filter(({ isActive }) => isActive)
        .map((field, index) => (
          <div key={index} style={{ flex: "0 0 30%" }}>
            <Fields
              {...field}
              {...{ values, errors, handleBlur, handleChange, setFieldValue }}
            />
          </div>
        ))}
    </Form.Row>
  );
};
